import React, { useState, useEffect } from 'react'
import RenderFields from '../../../components/common/RenderFields'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import InsertFile from "../../../assets/images/icons/insertFileUpload.svg";
import { postDataFromApi, GetTenantDetails } from '../../../services/commonServices';
import { masterUploadApi, ccCertWordApi } from '../../../services/api';
import Document from "../../../formJsonData/Operations/jobinstructions/DocumentPopup.json";
import Loading from '../../../components/common/OverlayLoading';
import { toast } from 'react-toastify';
import { getMailBodyDetails, getMailSubjectDetails } from '../../../services/commonFunction';
import { decryptDataForURL } from '../../../utills/useCryptoUtils';



const DocumentPopup = ({
    setUploadPopup,
    sectionIndex,
    formData,
    handleFieldChange,
    formErrors,
    viewOnly,
    editOnly,
    actionClicked,
    handleUploadDocument,
    popupType,
    setPopupType,
    selectedDoc,
    popupJson,
    fileUrl,
    setFileUrl,
    isExternalUse,
    moduleType,
    setFormData,
    isMultiUpload,
    setIsMultiUpload,
    setUploadedFile,
    isWordFile,
    EditRecordId
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const session = useSelector((state) => state.session);
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const iscustomformatupload = decryptDataForURL(params.get("iscustomformatupload")) || formData[0]?.is_custom_format_upload;

    const [isLoading, setIsLoading] = useState(false);
    const [convertedPdfFile, setConvertedPdfFile] = useState(session?.wordPreviewPdfFile || null);
    const [previewPdfUrl, setPreviewPdfUrl] = useState(null);

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        if (!files.length) return;

        handleUploadFiles(files);
    };

    const handleUploadFiles = async (files) => {

        // Validate file types based on mode
        if (isWordFile === "Yes" || iscustomformatupload) {
            const allowedExtensions = ['doc', 'docx'];
            const invalidFiles = files.filter(file => {
                const fileExtension = file.name.split('.').pop().toLowerCase();
                return !allowedExtensions.includes(fileExtension);
            });

            if (invalidFiles.length > 0) {
                toast.error(`Only Word files (DOC, DOCX) are allowed. Invalid: ${invalidFiles.map(f => f.name).join(', ')}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return;
            }
        } else if (isExternalUse) {
            const allowedExtensions = ['pdf', 'doc', 'docx'];
            const invalidFiles = files.filter(file => {
                const fileExtension = file.name.split('.').pop().toLowerCase();
                return !allowedExtensions.includes(fileExtension);
            });

            if (invalidFiles.length > 0) {
                toast.error(`Only PDF and Word files (DOC, DOCX) are allowed. Invalid: ${invalidFiles.map(f => f.name).join(', ')}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return;
            }
        }

        // If Word file mode, skip S3 upload — just save the file and proceed
        if (isWordFile === "Yes" || iscustomformatupload) {
            if (setUploadedFile) {
                setUploadedFile(files[0]);
            }
            setIsLoading(true);
            try {
                const wordFormData = new FormData();
                wordFormData.append('word_file', files[0]);
                wordFormData.append('cc_id', formData[0]?.cc_id);
                wordFormData.append('tenant', GetTenantDetails(1));
                wordFormData.append('is_custom_format_upload', iscustomformatupload);

                const wordRes = await postDataFromApi(
                    ccCertWordApi,
                    wordFormData,
                    "TRUE",
                    true
                );

                if (wordRes?.status === 200 || wordRes?.status === 201) {
                    const contentType = wordRes.headers?.['content-type'] || '';
                    const isPdf = contentType.includes('application/pdf');
                    const fileName = isPdf
                        ? files[0].name.replace(/\.(doc|docx)$/i, '.pdf')
                        : files[0].name.replace(/\.(doc)$/i, '.docx');
                    const fileType = isPdf ? 'application/pdf' : contentType;
                    const pdfFile = new File([wordRes.data], fileName, { type: fileType });

                    // Clean up previous preview URL if any
                    if (previewPdfUrl) URL.revokeObjectURL(previewPdfUrl);

                    const blobUrl = URL.createObjectURL(pdfFile);
                    setConvertedPdfFile(pdfFile);
                    setPreviewPdfUrl(blobUrl);

                    // Dispatch to Redux and navigate to preview page
                    dispatch({
                        type: "WORD_PREVIEW",
                        pdfFile: pdfFile,
                        pdfUrl: blobUrl,
                        is_custom_file_format: iscustomformatupload || false
                    });
                    setUploadPopup(false);
                    navigate("/operation/word-certificate-preview");
                } else {
                    toast.error("Word file processing failed", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            } catch (error) {
                console.error("Word API error:", error);
                toast.error(error?.response?.data?.message || "Error processing Word file", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } finally {
                setIsLoading(false);
            }
            return;
        }

        const uploadFormData = new FormData();


        uploadFormData.append("model_type", isExternalUse ? "commercial_certificate" : "userdata");

        if (isMultiUpload) {
            uploadFormData.append("is_multiple_upload", isMultiUpload);
            files.forEach((file) => {
                uploadFormData.append("files", file);
            });
        }
        else {
            uploadFormData.append("file", files[0])
        }

        setIsLoading(true);
        try {
            let response = await postDataFromApi(masterUploadApi, uploadFormData, "TRUE");
            if (response.data.status === 200) {
                setPopupType("UploadInfo");
                setIsLoading(false);
                if (isMultiUpload) {
                    const files = response.data.data;

                    const cleanedFiles = Object.fromEntries(
                        Object.entries(files).map(([key, value]) => [
                            key,
                            value?.split('?')?.[0] || ''
                        ])
                    );
                    setFileUrl(cleanedFiles);
                }
                else {
                    setFileUrl(response.data.data.file?.split('?')?.[0] || '');
                    if (setUploadedFile) {
                        setUploadedFile(files[0]);
                    }
                }

            }
            else {
                toast.error(
                    response?.message ||
                    response?.data?.message,
                    {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    }
                );
            }
        } finally {
            setIsLoading(false);
        }
    };
    const triggerFileInput = () => {
        document.getElementById("hiddenFileInput").click();
    };

    const [dragging, setDragging] = useState(false);

    const handleDragEnter = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragging(true);
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragging(false);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragging(true);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragging(false);
        const fileEvent = {
            target: {
                files: event.dataTransfer.files,
            },
        };

        handleFileChange(fileEvent);
    };

    useEffect(() => {
        const dropArea = document.getElementById("popupUploadContainer");

        dropArea?.addEventListener("dragenter", handleDragEnter);
        dropArea?.addEventListener("dragleave", handleDragLeave);
        dropArea?.addEventListener("dragover", handleDragOver);
        dropArea?.addEventListener("drop", handleDrop);
        setFormData((prev) => ({
            ...prev,
            [1]: {
                ...prev[1],
                ds_shared_with: formData?.[0]?.ji_client_cc_emails || []
            },
        }));
        return () => {
            dropArea?.removeEventListener("dragenter", handleDragEnter);
            dropArea?.removeEventListener("dragleave", handleDragLeave);
            dropArea?.removeEventListener("dragover", handleDragOver);
            dropArea?.removeEventListener("drop", handleDrop);
            if (previewPdfUrl) URL.revokeObjectURL(previewPdfUrl);
        };
    }, []);
    const uploadExtraModules = ['tenderDocumentList', 'purchaseorderDocumentList', 'purchasereqDocumentList', 'jrfDocumentList', 'itemDocumentList', "creditNoteDocumentList", "OnAccountDocumentList", "verificationDocumentList", "JobCostingDocumentList", "transferStockDocumentList"]
    return (
        <div className="popupSearchContainerBG">
            {isLoading ? <Loading /> :
                <>
                    {popupType === "Info" ?
                        <div className="popupSearchContainer documentInfoPopup">
                            <h2>
                                Document Info
                                <i
                                    className="bi bi-x-lg h4"
                                    onClick={() => setUploadPopup(false)}
                                ></i>
                            </h2>
                            <div className="popupAbout">
                                <p>
                                    <span>Name : </span> {selectedDoc.dl_document_name}
                                </p>
                                <p>
                                    <span>Type : </span>
                                    {selectedDoc?.dl_type}
                                </p>
                                <p>
                                    <span>Document Description : </span>
                                    {selectedDoc.dl_discription}
                                </p>
                                {/* <p>
                                    <span>Shared URL : </span>
                                    {selectedDoc.dl_s3_url}
                                </p> */}

                                <p>
                                    <span>Created on : </span>{" "}
                                    {selectedDoc.dl_created_at ? new Date(selectedDoc.dl_created_at).toLocaleDateString("en-GB") : ""}
                                </p>
                                <p>
                                    <span>Updated on : </span>{" "}
                                    {selectedDoc.dl_updated_at ? new Date(selectedDoc.dl_updated_at).toLocaleDateString("en-GB") : ""}
                                </p>

                            </div>
                        </div>
                        : popupType === "Upload" ?
                            <div className="popupSearchContainer documentPopup">
                                <h2>
                                    Upload File
                                    <i
                                        className="bi bi-x-lg h4"
                                        onClick={() => {
                                            setIsMultiUpload(false)
                                            setUploadPopup(false)
                                        }}
                                    ></i>
                                </h2>

                                <div
                                    id="popupUploadContainer"
                                    className={`popupUploadContainer ${dragging ? "dragging" : ""}`}
                                >
                                    <div onClick={triggerFileInput} className="fileUpoadContainer">
                                        <div className='insertFileUpload'>
                                            <img src={InsertFile} alt="InsertFile" />
                                            <p>Click and Drag file here or Choose file</p>
                                        </div>


                                        {/* <span>Drag and Drop or Click to Upload</span> */}
                                        <input
                                            type="file"
                                            id="hiddenFileInput"
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}
                                            multiple={isMultiUpload}
                                            accept={isWordFile === "Yes" || iscustomformatupload ? ".doc,.docx" : isExternalUse ? ".pdf,.doc,.docx" : undefined}
                                        />
                                    </div>
                                </div>
                            </div>
                            : popupType === "UploadInfo" ?

                                <div className="popupSearchContainer documentPopup documentInfoPopup">
                                    <h2>
                                        Document Info
                                        <i
                                            className="bi bi-x-lg h4"
                                            onClick={() => setUploadPopup(false)}
                                        ></i>
                                    </h2>
                                    {Document.upload.infoJson.body.map((field, fieldIndex) => {
                                        if (isMultiUpload) {
                                            if (field.name === "dl_document_name") {
                                                return null
                                            }
                                        }
                                        if (moduleType === "verificationDocumentList") {
                                            if (field.name === "dl_document_name") {
                                                field = {
                                                    ...field,
                                                    "title": "Sample Code",
                                                    "type": "DropDownWithLoadMore",
                                                    "apiendpoint": "/sampleverificationdetail/labcodes/",
                                                    "model_name": "",
                                                    "apimethod": "GET",
                                                    "queryString": "sv_id=" + EditRecordId,
                                                    "isSearchable": true,
                                                    "optionData": {
                                                        "id": "svd_smpllabcode",
                                                        "label": "svd_smpllabcode"
                                                    }
                                                }
                                            }
                                        }
                                        return (
                                            <div
                                                key={"Field Index" + fieldIndex}
                                                className={"col-md-" + field.width + " uploadRenderFields"}
                                            >
                                                <RenderFields
                                                    field={field}
                                                    sectionIndex={sectionIndex}
                                                    fieldIndex={fieldIndex}
                                                    formData={formData}
                                                    handleFieldChange={handleFieldChange}
                                                    formErrors={formErrors}
                                                    ///For View Only
                                                    viewOnly={viewOnly && !iscustomformatupload}
                                                    editOnly={editOnly && !iscustomformatupload}
                                                    actionClicked={actionClicked}
                                                />
                                            </div>
                                        )
                                    })}
                                    <div className="rejectButtonsContainer">
                                        <div className="popupSearchButtons">
                                            <button type="button" onClick={() => setUploadPopup(false)}>
                                                Cancel
                                            </button>
                                            <button type="button" disabled={isLoading} onClick={async () => {
                                                setIsLoading(true);
                                                try {
                                                    await handleUploadDocument();
                                                    if (previewPdfUrl) URL.revokeObjectURL(previewPdfUrl);
                                                    dispatch({ type: "WORD_PREVIEW_CLEAR" });
                                                } finally { setIsLoading(false); }
                                            }}>
                                                {isLoading ? "Saving..." : "Save"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="popupSearchContainer documentPopup documentInfoPopup">
                                    <h2>
                                        {popupJson?.heading}
                                        <i
                                            className="bi bi-x-lg h4"
                                            onClick={() => setUploadPopup(false)}
                                        ></i>
                                    </h2>
                                    {popupJson?.heading === "Share File" && <div className="advanceShare">
                                        <span
                                            onClick={() => {
                                                dispatch(
                                                    {
                                                        type: "SHARED_FILES",
                                                        selectedMultiDocs: [selectedDoc],
                                                        ccEmails: formData[0]?.ji_client_cc_emails,
                                                        clientEmails: formData[0]?.ji_client_email,
                                                        ccMailSubject: getMailSubjectDetails(formData, selectedDoc),
                                                        ccMailBody: getMailBodyDetails(formData, selectedDoc),
                                                    }
                                                );
                                                if (uploadExtraModules.includes(moduleType)) {
                                                    const mainmodule = moduleType.replace("DocumentList", "");
                                                    navigate(`/${mainmodule}List/${mainmodule}-document-list/document/ShareFiles`);
                                                }
                                                else {
                                                    navigate("/operation/ShareFiles");
                                                }
                                            }}
                                        >
                                            Show Advanced
                                        </span>
                                    </div>}
                                    {popupJson?.body?.map((field, fieldIndex) => (
                                        <div
                                            key={"Field Index" + fieldIndex}
                                            className={"col-md-" + field.width + " uploadRenderFields"}
                                        >
                                            <RenderFields
                                                field={field}
                                                sectionIndex={sectionIndex}
                                                fieldIndex={fieldIndex}
                                                formData={formData}
                                                handleFieldChange={handleFieldChange}
                                                formErrors={formErrors}
                                                ///For View Only
                                                viewOnly={viewOnly}
                                                // editOnly={editOnly}
                                                actionClicked={actionClicked}
                                            />
                                        </div>
                                    ))}
                                    <div className="rejectButtonsContainer">
                                        <div className="popupSearchButtons">
                                            <button type="button" onClick={() => setUploadPopup(false)}>
                                                Cancel
                                            </button>
                                            <button type="button" disabled={isLoading} onClick={async () => {
                                                setIsLoading(true);
                                                try { await handleUploadDocument(); } finally { setIsLoading(false); }
                                            }}>
                                                {isLoading ? "Saving..." : "Save"}
                                            </button>
                                        </div>
                                    </div>
                                </div>}
                </>}

        </div>
    )
}

export default DocumentPopup